// extracted by mini-css-extract-plugin
export default {"wrap":"tooltip-module_wrap_qDPp1","icon":"tooltip-module_icon_EfJcz"};